module.exports = __webpack_public_path__ + "img/pd_C2.3.2.5c6d02ac.png";